type DataLayerEvent = {
    event: string;
    ecommerce?: unknown;
    [key: string]: unknown;
};

type DataLayer = unknown[];

type PushGTMEventOptions = {
    resetEcommerce?: boolean;
};

export const pushGTMEvent = <Event extends DataLayerEvent>(
    event: Event,
    { resetEcommerce = true }: PushGTMEventOptions = {},
) => {
    if (typeof window === 'undefined') {
        return;
    }

    const dataLayerWindow = window as unknown as Window & { dataLayer?: DataLayer };
    dataLayerWindow.dataLayer = dataLayerWindow.dataLayer || [];

    if (resetEcommerce && Object.prototype.hasOwnProperty.call(event, 'ecommerce')) {
        dataLayerWindow.dataLayer.push({ ecommerce: null });
    }

    dataLayerWindow.dataLayer.push(event);
};
